<div [formGroup]="contactDetailsForm">
  <app-content-header
    text="Contact Details"
    *ngIf="isContactDetail"
  ></app-content-header>

  <ng-container *ngIf="!isContactDetail">
    <div class="d-flex align-items-center flex-row-reverse">
      <mat-slide-toggle
        (click)="toggleEmergency()"
        formControlName="isEmergencyContact"
      ></mat-slide-toggle>
      <span class="select-contact blue">Select as Emergency Contact</span>
    </div>
    <div
      *ngIf="f.isEmergencyContact.value"
      class="emergency-box"
    >
      <div class="emergency-title">An emergency contact must:</div>
      <div class="row no-gutters">
        <div class="col-auto">
          <img
            src="../../../../assets/svg/ico_paw_print.svg"
            width="12"
            class="paw-print"
            alt="Paw Print"
          />
        </div>
        <div class="col emergency-text">
          Live locally (within 30 minutes from Camp)
        </div>
      </div>
      <div class="row no-gutters">
        <div class="col-auto">
          <img
            src="../../../../assets/svg/ico_paw_print.svg"
            width="12"
            class="paw-print"
            alt="Paw Print"
          />
        </div>
        <div class="col emergency-text">Not be traveling with you</div>
      </div>
      <div class="row no-gutters">
        <div class="col-auto">
          <img
            src="../../../../assets/svg/ico_paw_print.svg"
            width="12"
            class="paw-print"
            alt="Paw Print"
          />
        </div>
        <div class="col emergency-text">
          Be able to pick up your dog and/or act on your behalf in case of an
          emergency
        </div>
      </div>
    </div>
    <hr />
  </ng-container>
  <!-- CBW-784 Names -->

  <div class="row no-gutters">
    <div
      class="input-container col"
      style="padding-right: 0.625rem"
    >
      <span class="input-label">First Name</span>
      <input
        title="firstName"
        type="text"
        class="input"
        formControlName="firstName"
        autocomplete="given-name"
      />
      <span
        *ngIf="f['firstName'].touched && f['firstName'].value === ''"
        class="error"
      >Please enter first name.</span>
    </div>
    <div
      class="input-container col"
      style="padding-left: 0.625rem"
    >
      <span class="input-label">Last Name</span>
      <input
        title="lastName"
        type="text"
        class="input"
        formControlName="lastName"
        autocomplete="family-name"
      />
      <span
        *ngIf="f['lastName'].touched && f['lastName'].value === ''"
        class="error"
      >Please enter last name.</span>
    </div>
  </div>

  <div
    *ngIf="isContactDetail"
    class="input-container"
  >
    <span class="input-label">Email Address</span>
    <input
      title="email"
      type="text"
      class="input disabled"
      value="email"
      formControlName="email"
      autocomplete="email"
      [attr.disabled]="''"
    />
    <span
      *ngIf="f['email'].touched && f['email'].value === ''"
      class="error"
    >Please enter email address.</span>
    <span
      *ngIf="
        f['email'].dirty &&
        f['email'].status == 'INVALID' &&
        f['email'].value !== ''
      "
      class="error"
    >Please check email address. E.g. woof@example.com</span>
  </div>

  <div formArrayName="phones">
    <div
      *ngFor="let phone of phoneArray.controls; index as i"
      [formGroupName]="i"
    >
      <div class="row no-gutters">
        <div
          class="col-7 input-container"
          style="padding-right: 0.625rem"
        >
          <span class="input-label">{{
            i === 0 ? "Phone Number" : "Additional Phone Number"
            }}</span>
          <div class="d-flex bd-highlight">
            <select
              title="countryCode"
              class="input"
              style="width: auto"
              name="countryCode"
              id="countryCode"
              autocomplete="tel-country-code"
              [attr.disabled]="''"
            >
              <option
                selected="selected"
                value="+1"
              >+1</option>
            </select>
            <input
              title="phoneNumber"
              type="text"
              class="input"
              formControlName="phoneNumber"
              autocomplete="tel-national"
              mask="(000) 000-0000"
            />
          </div>
          <span
            *ngIf="
              phone.get('phoneNumber').touched &&
              phone.get('phoneNumber').value === ''
            "
            class="error"
          >Please enter phone number.</span>
          <span
            *ngIf="
              phone.get('phoneNumber').touched &&
              phone.get('phoneNumber').hasError('pattern') &&
              phone.get('phoneNumber').value !== ''
            "
            class="error"
          >Please check phone number.</span>
        </div>

        <div
          class="dropdown input-container"
          [ngClass]="{ 'col-5': i === 0, 'col-4': i !== 0 }"
          style="padding-left: 0.625rem"
        >
          <span class="input-label">Type</span>
          <div class="d-flex align-content-center">
            <mat-form-field class="input">
              <mat-select
                name="type"
                id="type"
                formControlName="phoneType"
                [compareWith]="compareFn"
              >
                <mat-option
                  *ngFor="let phoneType of myProfileService.phoneTypeList"
                  [value]="phoneType"
                >{{ phoneType.type }}</mat-option>
              </mat-select>
            </mat-form-field>
            <img
              class="icon-container trash"
              src="../../../../assets/svg/ico_trash_can.svg"
              (click)="deletePhone(i)"
              alt="Trash Can Icon"
            />
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="!isContactDetail">
    <div class="input-container">
      <span class="input-label">Is this contact related to you?</span>
      <div class="row no-gutters">
        <div class="col col-sm-9">
          <app-binary-choice-selector
            [opt1]="yesNoList[0]"
            [opt2]="yesNoList[1]"
            [selectedValue]="f.isRelated.value"
            (selectedValueChange)="f.isRelated.setValue($event)"
          ></app-binary-choice-selector>
        </div>
      </div>
    </div>
    <div
      *ngIf="f.isRelated.value"
      class="dropdown input-container"
    >
      <span class="input-label">Relationship</span>
      <mat-form-field class="input">
        <mat-select formControlName="relationship">
          <mat-option
            *ngFor="let c of relations"
            [value]="c"
          >{{ c }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <app-arrow-link-right
    *ngIf="isContactDetail"
    (handleClick)="addAdditionalPhone()"
    text="+ Add a Phone Number"
  ></app-arrow-link-right>
</div>
